import { render, staticRenderFns } from "./DefaultSecretariat.vue?vue&type=template&id=06dfcf7e"
import script from "./DefaultSecretariat.vue?vue&type=script&lang=js"
export * from "./DefaultSecretariat.vue?vue&type=script&lang=js"
import style0 from "./DefaultSecretariat.vue?vue&type=style&index=0&id=06dfcf7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports